<template>
    <div>
      <Transfer_goods_edit/>
    </div>
  </template>
  
  <script>
  import Transfer_goods_edit from "@/components/adminArin/pos_system/warehouse/warehouse_all/Transfer_goods_edit";
  export default {
    name: "Transfergoodsedit",
    components: {
      Transfer_goods_edit
    }
  }
  </script>
  
  <style scoped>
  
  </style>
  